export const transformLeaderboardData = (data) => {
    return {
      global_rank: data.user_rank,
      User_Rank: data.jsSortRank,
      msisdn: data.msisdn || "",
      time_taken: data.total_time || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };
  export const transformLeaderboardDataArrayMemory = (dataArray) => {
    let jsSortRank = 1;
    if (Array.isArray(dataArray)) {
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (!Array.isArray(dataArray)) {
      return [];
    }
    return dataArray.map(data => transformLeaderboardData(data));
  };

  export const transformQuizardWinnerLeaderboardData = (data) => {
    return {
      global_rank:data.global_rank,
      User_Rank: data.jsSortRank,
      score:data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformQuizardWinnerLeaderboardDataArray = (dataArray,numberOfWinner=null) => {
    // After sorting, add jsSortRank to each object
    let jsSortRank = 1;
    if (Array.isArray(dataArray)) {
      dataArray = dataArray.slice().sort((a, b) => {
        const rankA = a.global_rank !== undefined ? a.global_rank : Infinity;
        const rankB = b.global_rank !== undefined ? b.global_rank : Infinity;
        return rankA - rankB;
      });
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (!Array.isArray(dataArray)) {
      return [];
    }
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformQuizardWinnerLeaderboardData(data));
    }
    return dataArray.map(data => transformQuizardWinnerLeaderboardData(data));
  };


  
  export const transformWinnerlistData = (data) => {
    return {
      global_rank:data.serial_no,
      User_Rank: data.jsSortRank,
      score:data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformWinnerlistDataArray = (dataArray,numberOfWinner=null,difficultyLevel=null) => {
    // After sorting, add jsSortRank to each object
    let jsSortRank = 1;

    if (!Array.isArray(dataArray)) {
      return [];
    }
    // INSERT_YOUR_CODE
    if (difficultyLevel != null) {
      dataArray = dataArray.filter(obj => obj.category === difficultyLevel);
    }
    if (Array.isArray(dataArray)) {
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformWinnerlistData(data));
    }
    return dataArray.map(data => transformWinnerlistData(data));
  };




  export const transformMemoryMatchWinnerLeaderboardDataArray = (dataArray,numberOfWinner=null) => {
    const transformQuizardWinnerLeaderboardData = (data) => {
      return {
        User_Rank: data.jsSortRank,
        score:data?.right_count|| 1,
        msisdn: data.msisdn || "",
        time_taken: data.total_time || 0,
        avatar_id: data.avatar_id || 1, // Default avatar ID
        avatar_img: data.avatar_img || "" // Empty avatar image
      };
    };
    // After sorting, add jsSortRank to each object
    let jsSortRank = 1;
    if (Array.isArray(dataArray)) {
      dataArray = dataArray.slice().sort((a, b) => {
        const rankA = a.rank !== undefined ? a.rank : Infinity;
        const rankB = b.rank !== undefined ? b.rank : Infinity;
        return rankA - rankB;
      });
      dataArray.forEach(obj => {
        obj.jsSortRank = jsSortRank++;
      });
    }
    if (!Array.isArray(dataArray)) {
      return [];
    }
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformQuizardWinnerLeaderboardData(data));
    }
    return dataArray.map(data => transformQuizardWinnerLeaderboardData(data));
  };


  export const transformDailyWinnerNData = (data) => {
    return {
      global_rank: data.serial_no,
      User_Rank: data.jsSortRank,
      score: data.right_count,
      msisdn: data.msisdn || "",
      time_taken: data.time_taken || 0,
      avatar_id: data.avatar_id || 1, // Default avatar ID
      avatar_img: data.avatar_img || "" // Empty avatar image
    };
  };

  export const transformDailyWinnerNDataArray = (dataArray, numberOfWinner = null) => {
    // API returns { message: "No records found" } (an object) when empty
    if (!Array.isArray(dataArray)) {
      return [];
    }
    // Sort by serial_no ascending to show proper serial, then assign display rank
    let jsSortRank = 1;
    dataArray = dataArray.slice().sort((a, b) => {
      const serialA = a.serial_no !== undefined ? a.serial_no : Infinity;
      const serialB = b.serial_no !== undefined ? b.serial_no : Infinity;
      return serialA - serialB;
    });
    dataArray.forEach(obj => {
      obj.jsSortRank = jsSortRank++;
    });
    if (numberOfWinner != null) {
      return dataArray.slice(0, numberOfWinner).map(data => transformDailyWinnerNData(data));
    }
    return dataArray.map(data => transformDailyWinnerNData(data));
  };
